/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AnalyticsSignalDimension,
  AnalyticsSignalDimension$Outbound,
  AnalyticsSignalDimension$outboundSchema,
} from "./analyticssignaldimension.js";
import {
  AnalyticsSignalFilter,
  AnalyticsSignalFilter$Outbound,
  AnalyticsSignalFilter$outboundSchema,
} from "./analyticssignalfilter.js";
import {
  AnalyticsSignalSelection,
  AnalyticsSignalSelection$Outbound,
  AnalyticsSignalSelection$outboundSchema,
} from "./analyticssignalselection.js";

export type AnalyticsSignalQuery = {
  filters?: Array<AnalyticsSignalFilter> | undefined;
  groupBy?: Array<AnalyticsSignalDimension> | undefined;
  /**
   * Top groups selected over the whole window
   */
  groups?: number | undefined;
  /**
   * Budget across complete selected series
   */
  points?: number | undefined;
  runId?: string | undefined;
  selection: AnalyticsSignalSelection;
  /**
   * Evaluation population: stream or manual
   */
  trigger?: string | undefined;
};

/** @internal */
export type AnalyticsSignalQuery$Outbound = {
  filters?: Array<AnalyticsSignalFilter$Outbound> | undefined;
  group_by?: Array<AnalyticsSignalDimension$Outbound> | undefined;
  groups: number;
  points: number;
  run_id?: string | undefined;
  selection: AnalyticsSignalSelection$Outbound;
  trigger: string;
};

/** @internal */
export const AnalyticsSignalQuery$outboundSchema: z.ZodMiniType<
  AnalyticsSignalQuery$Outbound,
  AnalyticsSignalQuery
> = z.pipe(
  z.object({
    filters: z.optional(z.array(AnalyticsSignalFilter$outboundSchema)),
    groupBy: z.optional(z.array(AnalyticsSignalDimension$outboundSchema)),
    groups: z._default(z.int(), 5),
    points: z._default(z.int(), 2000),
    runId: z.optional(z.string()),
    selection: AnalyticsSignalSelection$outboundSchema,
    trigger: z._default(z.string(), "stream"),
  }),
  z.transform((v) => {
    return remap$(v, {
      groupBy: "group_by",
      runId: "run_id",
    });
  }),
);

export function analyticsSignalQueryToJSON(
  analyticsSignalQuery: AnalyticsSignalQuery,
): string {
  return JSON.stringify(
    AnalyticsSignalQuery$outboundSchema.parse(analyticsSignalQuery),
  );
}
